$.fn.addUploadFieldValidationMessage = function (args) {
    /// <summary>Add a validation message to an upload field - element must be the wrapper with 'fuCont' class..</summary>
    /// <param name="args" type="Object">Options object, elementId to assign an id to the validation message and, message to display a non-default validation message</param>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    // no args so don't proceed
    if (!args) return;

    this.each(function (i, el) {

        var uploadField = $(el),
            valiMsgElement = cafm.forms.helpers.generateFieldValidationElement({
                elementId: args.elementId ? args.elementId : cafm.guid.newGuid(),
                message: args.message ? args.message : 'File must be uploaded'
            });

        valiMsgElement.insertBefore(uploadField.find('.progress'));
        uploadField.find('.uploaderPlc').addClass('k-invalid');
    })
}

$.fn.removeUploadFieldValidationMessage = function () {
    /// <summary>Remove a validation message and invalid state from an upload field</summary>
    /// <returns type="$">Returns the JQuery element(s)</returns>
    
    this.each(function (i, el) {

        var uploadField = $(el);
        uploadField.find('.k-invalid-msg').remove();
        uploadField.find('.uploaderPlc').removeClass('k-invalid');
    })
}

cafm.fu = {
    fileUploads: [],
    init: function () {

        var fuForm = $('#fileForm');
        var fuField = $('#fileUpload');
        var fuBtn = $('#fileUploadBtn');

        fuField.mouseover(function () {

            fuBtn.addClass('btnHover');
        }).mouseout(function () {

            fuBtn.removeClass('btnHover');
        });

        cafm.fu.fileChanged = function () {
            var uploadId = frameElement.attributes.getNamedItem('data-uploadid').value;
            var fu = parent.window.cafm.fu.getFileUpload(uploadId);
            fu.uploadForm = fuForm.get(0);
            fu.uploadFileField = fuField.get(0);
            fu.executeUpload();
        }

        var uploadId = frameElement.attributes.getNamedItem('data-uploadid').value;
        var fu = parent.window.cafm.fu.getFileUpload(uploadId);
        if (cafm.util.hasItem(fu.allowedExtensions)) {

            $('#fileUpload').attr('accept', fu.allowedExtensions.join(','));
        }
    },
    getUploadProgressUrl: function (uploadId) {
        return cafm.url.api('FileUploadProgress/Get/' + uploadId);
    },
    getStopUploadUrl: function (uploadId) {
        return cafm.url.api('FileUploadProgress/Stop/' + uploadId);
    },
    getUndoUploadUrl: function (uploadId) {
        return cafm.url.api('FileUploadProgress/Undo/' + uploadId);
    },
    newFileUpload: function (container, allowedExtensions) {
        var fu = cafm.fu.getFileUploadByContainer(container);
        if (fu) return fu;
        fu = new FileUpload(container);
        fu.allowedExtensions = allowedExtensions ? allowedExtensions.split(',') : [];
        this.fileUploads[fu.uploadId] = fu;
        if (isUndefined(this.firstUploadInit)) {
            fu.init();
            this.firstUploadInit = true;
        }
        return fu;
    },
    getFileUpload: function (uploadId) {
        return this.fileUploads[uploadId];
    },
    clearFileUploads: function () {
        this.fileUploads = [];
        delete this.firstUploadInit;
    },
    getFileUploadByContainer: function (c) {
        for (var uId in this.fileUploads) {
            var fu = this.fileUploads[uId];
            if (isFunc(fu)) continue;
            if (fu && fu.container.attr('id') == c.attr('id')) {
                return fu;
            }
        }
        return null;
    },
    removeFile: function (e) {

        var element = $(e.currentTarget), viewModel = element.getParentViewModel(), field = element.data('field');

        if (field) {

            viewModel.set('{0}.FileName'.format(field), null);
            viewModel.set('{0}.FileURL'.format(field), null);
            viewModel.set('{0}.FileRemoved'.format(field), true);
        }
        else if (viewModel) {

            viewModel.set('FileName', null);
            viewModel.set('FileURL', null);
            viewModel.set('FileRemoved', true);
        }
    },
    /// <field name='changePasswordAction' type='cafm.actions.Action'>The forms change password action</field>
    uploadProgressActionOptions: {
        id: 'UploadProgress',
        method: 'GET',
        requestDelay: 1500,
        url: function(a){
            return cafm.fu.getUploadProgressUrl(a.get('uploadId'));
        },
        statusCodeFuncs: {
            200: function (res, s, m, a) {
                var me = cafm.fu.getFileUpload(a.get('uploadId'));
                if (!me) return;
                me.status = res.Status;
                me.progressBar.removeClass('progressSuccess');
                me.progressBar.removeClass('progressError');
                switch (me.status) {
                    case cafm.enums.FileUploadProgress.InProgress:
                        if (res.PercentComplete > 0) {
                            var wMulti = $('.progress', me.container).width() / 100;
                            me.progressBar.animate({ width: parseInt(res.PercentComplete * wMulti) }, 150);
                            me.progressTxt.text(res.PercentComplete + '%');
                        }
                        if (res.PercentComplete < 100) {
                            me.showProgress(me);
                        }
                        break;
                    case cafm.enums.FileUploadProgress.Complete:
                        me.progressBar.addClass('progressSuccess');
                        delete me.iUploader;
                        var uPlc = $('.uploaderPlc', me.container);
                        uPlc.children().remove();
                        uPlc.html(me.filename);
                        me.progressBar.animate({ width: '100%' }, 150, function () {
                            me.progressTxt.text(res.Message);
                            uPlc.attr('data-readonly', true);
                            //uPlc.fadeIn();
                            me.cancelBtn.addClass('undoUpload');
                            $(me.cancelBtn).unbind('click').bind('click', function () {
                                me.undoUpload(me);
                                return false;
                            });
                            if (isFunc(me.onComplete)) {
                                me.onComplete();
                            }
                        });
                        break;
                    case cafm.enums.FileUploadProgress.Failed:
                        me.reset(me);
                        me.showProgressError(me, res.Message);
                        return;
                }
            }
        }
    },
    stopUploadActionOptions: {
        id: 'StopUpload',
        url: function (a) {
            return cafm.fu.getStopUploadUrl(a.get('uploadId'));
        },
        statusCodeFuncs: {
            204: function (r, s, m, me) {
                var fu = cafm.fu.getFileUpload(me.get('uploadId'));
                if (fu) fu.reset(fu);
            }
        }
    },
    undoUploadActionOptions: {
        id: 'UndoUpload',
        url: function (a) {
            return cafm.fu.getUndoUploadUrl(a.get('uploadId'));
        },
        statusCodeFuncs: {
            204: function (r, s, m, me) {
                var fu = cafm.fu.getFileUpload(me.get('uploadId'));
                if(fu) fu.reset(fu);
            }
        }
    }
}

class FileUpload {

    constructor (container) {
        this.uploadId = cafm.guid.newGuid();
        this.container = container;
        this.progressTxt = $('.progressTxt', container);
        this.progressBar = $('.progressBar', container);
        this.uploadIdField = $('[data-role="uploadId"]', container);
        this.cancelBtn = $('.cancelUpload', container);
        this.container.attr('data-id', this.uploadId);
        this.allowedExtensions = [];
        this.container.find('.file-remove').off('click.cafm').on('click.cafm', cafm.fu.removeFile);
    }

    executeUpload() {
        try {
            var me = this;

            // remove validation - new upload starting
            me.container.removeUploadFieldValidationMessage();

            me.uploadIdField.val(me.uploadId).trigger('change');
            $(me.cancelBtn).unbind('click').bind('click', function () {
                me.stopUpload(me);
                return false;
            });
            this.progressBar.width(0);
            var filepath = this.uploadFileField.value;
            this.filename = filepath.substr(filepath.lastIndexOf('\\') + 1);

            // ensure there are no '&' in the file name as it will form part of the query string
            if (this.filename.indexOf('&') > -1) {

                this.filename = this.filename.replace(/&/g, ' ');
            }

            // check for a file extension
            if (this.filename.lastIndexOf('.') == -1) {

                this.showProgressError(this, 'The file is not valid');
                return;
            }

            if (cafm.util.hasItem(this.allowedExtensions)) {
                var ext = this.filename.substr(this.filename.lastIndexOf('.'));
                if (!cafm.util.exists(this.allowedExtensions, function (e) { return e.trim() === ext.toLowerCase() })) {
                    this.showProgressError(this, cafm.res.str.MessageFileNotValid);
                    cafm.msg.showMessageInWindow({
                        type: cafm.enums.MessageType.Error,
                        title: '{0}. {1}'.format(cafm.res.str.MessageFileNotValid, cafm.res.str.TemplateAllowedFileTypesInclude0.format(this.allowedExtensions.join(', ')))
                    });
                    return;
                }
            }

            this.ext = this.filename.substr(this.filename.lastIndexOf('.'));
            this.uploadForm.action = cafm.url.get('Task/Files/Upload') + '?{0}&{1}'.format(this.uploadId, this.filename);
            this.uploadForm.submit();
            this.progressBar.width(0);
            this.progressTxt.text(cafm.res.str.MessageInitUpload);
            this.showProgress(this);
            this.cancelBtn.show();
        }
        catch (err) {
            this.showProgressError('Script error');
            me.cancelBtn.hide();
            me.initFrame(me);
            alert(err);
        }
    }
    stopUpload(me) {
        me.uploadIdField.val('');
        cafm.fu.stopUploadActionOptions.uploadId = me.uploadId;
        cafm.actions.execute(cafm.fu.stopUploadActionOptions);
    }
    undoUpload(me) {
        me.uploadIdField.val('');
        cafm.fu.undoUploadActionOptions.uploadId = me.uploadId;
        cafm.actions.execute(cafm.fu.undoUploadActionOptions);
    }
    showProgress(me) {
        cafm.fu.uploadProgressActionOptions.uploadId = me.uploadId;
        cafm.actions.execute(cafm.fu.uploadProgressActionOptions);
    }
    showProgressError(me, msg) {
        me.progressBar.addClass('progressError');
        me.progressBar.animate({ width: '100%' }, 150, function () {
            me.progressTxt.text(msg);
            if (typeof (me.onError) == 'function') {
                me.onError();
            }
        });
    }
    init() {
        this.initFrame(this);
        if (cafm.util.hasItem(this.allowedExtensions)) {
            for (var i = 0; i < this.allowedExtensions.length; i++) {
                this.allowedExtensions[i] = this.allowedExtensions[i].trim();
            };
        }
    }
    initFrame(me) {
        var upUrl = cafm.url.get('Task/Files/Upload');
        if (me.iUploader) {
            me.iUploader.attr('src', upUrl);
        }
        else {
            var uPlc = $('.uploaderPlc', me.container);
            uPlc.text('');
            me.iUploader = $('<iframe />', {
                src: upUrl,
                frameborder: 0,
                width: '100%',
                height: '100%',
                scrolling: 'no',
                'data-uploadid': me.uploadId
            }).appendTo(uPlc);
        }
    }
    reset(me) {
        me.cancelBtn.hide();
        me.cancelBtn.removeClass('undoUpload');
        delete me.filename;
        delete me.ext;
        delete me.status;
        me.progressTxt.text('');
        me.progressBar.animate({ width: 0 }, 150);
        $('.uploaderPlc', me.container).removeAttr('data-readonly');
        me.initFrame(me);
    }
}